import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  Autocomplete,
  Container,
} from "@mui/material";
import BackBtn from "../../../widgets/BackBtn";
import PageTitle from "../../../widgets/PageTitle";
import { GlassButton } from "../../../themes/UiElements";

const steps = ["Basic Info", "Ownership"];

export default function AddItemForm() {
  const [activeStep, setActiveStep] = useState(0);
  const [tagsOptions, setTagsOptions] = useState([
    "Education",
    "Technology",
    "Healthcare",
    "Finance",
    "Art",
    "Sports",
  ]);

  const [formData, setFormData] = useState({
    name: "",
    tags: [],
    creator: "",
    owner: "",
  });

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    // Send data to backend here
  };

  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <Box mt={2}>
        <PageTitle mb={2}>Create Item</PageTitle>
        <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <form onSubmit={handleSubmit}>
          {activeStep === 0 && (
            <Box display="flex" flexDirection="column" gap={3}>
              {/* Name Field */}
              <TextField
                label="Name"
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
                required
              />

              {/* Tags with Add Option */}
              <Autocomplete
                multiple
                freeSolo
                options={tagsOptions}
                value={formData.tags}
                onChange={(e, newValue) => {
                  const lastValue = newValue[newValue.length - 1];
                  // If last entered value is not already in options, add it
                  if (lastValue && !tagsOptions.includes(lastValue)) {
                    setTagsOptions((prev) => [...prev, lastValue]);
                  }
                  handleChange("tags", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tags"
                    placeholder="Select or add tags"
                  />
                )}
              />

              {/* Next Button */}
              <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button variant="contained" onClick={handleNext}>
                  Next
                </Button>
              </Box>
            </Box>
          )}

          {activeStep === 1 && (
            <Box display="flex" flexDirection="column" gap={2}>
              {/* Creator */}
              <TextField
                label="Creator"
                value={formData.creator}
                onChange={(e) => handleChange("creator", e.target.value)}
                required
              />
              {/* Owner */}
              <TextField
                label="Owner"
                value={formData.owner}
                onChange={(e) => handleChange("owner", e.target.value)}
                required
              />

              {/* Back & Submit */}
              <Box display="flex" justifyContent="space-between" mt={2}>
                <GlassButton variant="outlined" onClick={handleBack}>
                  Back
                </GlassButton>
                <GlassButton type="submit" variant="contained" color="primary">
                  Submit
                </GlassButton>
              </Box>
            </Box>
          )}
        </form>
      </Box>
    </Container>
  );
}
